__turbopack_context__.v({
  "image": "image-module-scss-module__oJCQYa__image",
});
